import { toJpeg} from "html-to-image";

export const saveToJPG = (elementID, invoiceName) => {
    toJpeg(elementID.current, { quality: 0.95 })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = `${invoiceName}.jpg`;
        link.click();
      })
      .catch((error) => {
        console.error('Error capturing the element as an image:', error);
      })
}